module.exports = __webpack_public_path__ + "img/pdf-1.e0a992b3.svg";